import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <footer id="sticky-footer" className="py-4">
        <div className="container">
          <p className="card-text align-items-center" style={{background: "#f2fffa", maxWidth: "60%", margin: "0 auto", display: "flex", justifyContent: "center"}}>
            {this.props.footer ? <img alt="colsubsidio" src={this.props.footer} style={{maxWidth: "100%", display: "block", margin: "0 auto"}}/> : ""}
          </p>
        </div>
      </footer>
    )
  }
}

export default Footer;
